import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { ErrorBoundary } from 'config/sentry';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useBackOfficeDeviceCameraSamplePoint } from 'store/modules/backOfficeDevice/hooks';
import SamplePoint from 'types/models/samplePoint';

import CameraDataUsage from '../CameraDataUsage';
import CameraDetails from '../CameraDetails';

export default function BackOfficeDeviceCameraForm() {
  const [searchParams] = useSearchParams();
  const deviceId = Number(searchParams.get(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE)) || undefined;
  const cameraSamplePoint = useBackOfficeDeviceCameraSamplePoint(deviceId);

  if (!cameraSamplePoint) return null;
  return (
    <>
      <div className="section-heading">Camera</div>

      <ErrorBoundary>
        {/* HACK: The type assertion here can cause potential problems if usage surpasses GetSamplePointDto fields */}
        <CameraDetails isBackOffice samplePoint={cameraSamplePoint as SamplePoint} />
        <br />
        {/* HACK: The type assertion here can cause potential problems if usage surpasses GetSamplePointDto fields */}
        <CameraDataUsage isBackOffice samplePoint={cameraSamplePoint as SamplePoint} />
      </ErrorBoundary>
    </>
  );
}
